import type { LocaleResource } from './types';
import { getA11yFallback } from './a11yFallback';

const resource = {
  common: {
    loading: 'Inapakia...',
    actions: {
      close: 'Funga menyu',
      search: 'Tafuta',
      backHome: 'Rudi nyumbani',
      login: 'Ingia',
      register: 'Fungua akaunti',
      explore: 'Chunguza',
    },
    states: {
      noResults: 'Hakuna matokeo',
      noResultsFor: 'Hakuna matokeo ya “{{query}}”.',
    },
  },
  app: {
    skipToContent: 'Nenda kwenye maudhui kuu',
    loading: 'Inapakia...',
    notFound: {
      message: 'Ukurasa huu haupo katika ulimwengu wa Skoleom.',
      cta: 'Rudi nyumbani',
    },
  },
  a11y: getA11yFallback('sw'),
  header: {
    brandHome: 'Nyumbani',
    universe: 'Universe',
    navLabel: 'Urambazaji mkuu',
    searchPlaceholder: 'Tafuta',
    searchAria: 'Tafuta',
    language: {
      change: 'Badilisha lugha',
      zones: {
        international: 'Kimataifa',
        europe: 'Ulaya na Uingereza',
        americas: 'Amerika',
        mena: 'MENA',
        asiaPacific: 'Asia Pasifiki',
        africa: 'Afrika',
      },
    },
    actions: {
      settings: 'Mipangilio',
      favorites: 'Vipendwa',
      cart: 'Kikapu',
      account: 'Akaunti ya mtumiaji',
      openMenu: 'Fungua menyu',
      closeMenu: 'Funga menyu',
    },
    account: {
      dashboard: 'Dashibodi yangu',
      orders: 'Oda zangu',
      favorites: 'Vipendwa',
      admin: 'Dashibodi ya admin',
      adminBadge: 'Admin',
      logout: 'Toka',
    },
    nav: {
      home: 'Nyumbani',
      stores: 'Maduka',
      music: 'Muziki',
      subscriptions: 'Usajili',
      everyone: 'Kwa wote',
      pros: 'Kwa wataalamu',
      news: 'Habari',
      events: 'Matukio',
      group: 'Kundi',
      support: 'Usaidizi',
    },
  },
  cart: {
    title: 'Kikapu changu',
    itemCount: '{{count}} bidhaa',
    empty: {
      title: 'Kikapu chako kiko tupu',
      subtitle: 'Gundua maudhui yetu yanayoweza kununuliwa',
    },
    summary: {
      subtotal: 'Jumla ndogo',
      shipping: 'Usafirishaji',
      free: 'Bure',
      total: 'Jumla',
    },
    checkout: {
      cta: 'Lipa kwa Skoleom Pay',
      security: 'Malipo huru na salama · yanatii GDPR',
    },
    aria: {
      decrease: 'Punguza idadi',
      increase: 'Ongeza idadi',
      remove: 'Ondoa bidhaa hii',
      close: 'Funga kikapu',
    },
  },
  skoleomPage: {
    nav: {
      ariaLabel: 'Urambazaji wa Skoleom Page',
      home: 'Nyumbani',
      homeMobile: 'Nyumbani',
      trends: 'Mitindo',
      trendsMobile: 'Mitindo',
      create: 'Unda SeContent yako',
      createMobile: 'Unda',
      profile: 'Wasifu',
      profileMobile: 'Wasifu',
    },
    explorer: {
      poweredBy: 'Inaendeshwa na SeSync',
      heroBefore: 'Tazama. Bofya. ',
      heroHighlight: 'Gundua.',
      heroSubtitle:
        'Utafutaji mmoja, mfumo wote wa Skoleom Universe — video, muziki, media, ununuzi. Kila matokeo ni mlango wa kina.',
      logoAlt: 'Skoleom Page',
      searchPlaceholder: 'Tafuta msanii, filamu, chapa…',
      searchAria: 'Neno la utafutaji',
      searchSubmit: 'Anza utafutaji',
      searchReset: 'Weka upya utafutaji',
      exploreCta: 'Chunguza',
      resultsFor: 'Matokeo kwa',
      resultsOnPlatforms_one: 'kwenye jukwaa {{count}}',
      resultsOnPlatforms_other: 'kwenye majukwaa {{count}}',
      filter: 'Chuja',
      platforms: 'Majukwaa',
      filterPlatformsAria: 'Chuja majukwaa',
      selectAll: 'Zote',
      selectNone: 'Hakuna',
      loading: 'Inaunganisha na ulimwengu wa Skoleom…',
      noResults: 'Hakuna matokeo yanayolingana na vichujio vyako. Chagua majukwaa zaidi.',
    },
    actionCards: {
      sectionBefore: 'Gundua ',
      sectionHighlight: 'ulimwengu wa Skoleom',
      mobile: {
        title: 'Simu',
        description: 'Inapatikana kwenye iOS na Android.',
      },
      tv: {
        title: 'TV',
        description: 'Tazama kwenye TV yako iliyounganishwa.',
      },
      rewards: {
        title: 'Zawadi',
        description: 'Cashback kwa ununuzi wa premium.',
      },
      extension: {
        title: 'Kiendelezi',
        description: 'Fikia vipengele vyote.',
      },
      audio: {
        title: 'Sauti',
        description: 'Sikiliza kwenye vifaa vyako vyote.',
      },
      gaming: {
        title: 'Michezo',
        description: 'Gundua programu zetu za michezo.',
      },
    },
  },
  footer: {
    brand: {
      description:
        'Mfumo wa Skoleom huunganisha maduka ya sauti na video, zana za waundaji na suluhu za biashara ili kufanya maudhui yawe shirikishi na yanayoweza kutumika.',
    },
    socials: {
      label: 'Mitandao ya kijamii ya Skoleom',
    },
    shopPrompt: {
      prefix: 'Unaweza pia kununua katika',
      link: 'duka la mtandaoni la Skoleom',
    },
    copyright: 'Haki zote zimehifadhiwa.',
    modal: {
      close: 'Funga menyu',
      title: 'Huduma haipatikani',
      body: 'Huduma hii haipatikani katika eneo lako.',
    },
    columns: {
      about: 'Kuhusu Skoleom',
      stores: 'Maduka rasmi ya sauti na video',
      everyone: 'Kwa wote',
      pros: 'Kwa wataalamu',
      group: 'Kundi',
      '1': 'Kuhusu Skoleom',
      '2': 'Maduka ya sauti na picha',
      '3': 'Kwa wote',
      '4': 'Kwa wataalamu',
      '5': 'Kundi',
    },
    links: {
      '101': 'Dhamira yetu',
      '102': 'Teknolojia yetu',
      '103': 'Mfumo wa Skoleom',
      '104': 'Programu za ufadhili',
      '105': 'Hati miliki ya Skoleom',
      '201': 'Chunguza maduka',
      '202': 'Ulimwengu kwa kategoria',
      '203': 'Unda duka',
      '301': 'Jinsi inavyofanya kazi',
      '302': 'Tazama na nunua',
      '303': 'Cashback na zawadi',
      '304': 'Skoleom Wallet',
      '305': 'Usalama na faragha',
      '401': 'Suluhu za biashara',
      '402': 'Chumisha maudhui yako',
      '403': 'Unda duka la sauti na video',
      '404': 'Sambaza bidhaa zako',
      '405': 'Matangazo shirikishi',
      '406': 'API na miunganisho',
      '407': 'Unda Audiovisual Store Page',
      '501': 'Habari',
      '502': 'Kazi',
      '503': 'Wawekezaji',
      '504': 'Vyombo vya habari',
      '505': 'Mawasiliano',
      '506': 'Usaidizi',
    },
    legalLinks: {
      '901': 'Taarifa za kisheria',
      '902': 'Masharti ya matumizi na mauzo',
      '903': 'Faragha',
      '904': 'Ufichuzi wa ushirika',
      '905': 'Mapendeleo ya vidakuzi',
      '906': 'Sera ya kurejesha pesa',
    },
  },
  auth: {
    login: {
      title: 'Ingia',
      submit: 'Ingia',
    },
    register: {
      title: 'Fungua akaunti',
      submit: 'Fungua akaunti',
    },
  },
  dashboard: {
    user: {
      orders: 'Oda zangu',
    },
    admin: {
      title: 'Dashibodi ya admin',
    },
  },
  home: {
    hero: {
      title: 'Gundua ekosistimu ya kimataifa ya Skoleom Group',
      description: {
        intro: 'Skoleom Group inabadilisha ',
        economy: 'uchumi wa kidijitali',
        mid: ' kwa kuwezesha ununuzi wa papo hapo katika maudhui ya sauti na picha. Imeunganishwa na zaidi ya ',
        ott: 'majukwaa 2000 ya OTT',
        join: ' na ',
        web: 'mabilioni ya tovuti',
        outro: ', teknolojia yetu hubadilisha kila skrini kuwa sehemu ya mauzo shirikishi.',
      },
      download: 'Pakua',
      application: 'programu',
      extension: 'kiendelezi',
      watchVideo: 'Tazama video',
      tagline1: 'KILA VIDEO HUWA DUKA LA KWELI LA KINA:',
      tagline2:
        'UZOEFU LAINI, LA KISTAARABU NA LA MAINGILIANO, UNAPOGUNDUA, KUGUSA NA KUNUNUA PAPO HAPO UNACHOKIONA.',
    },
    actions: {
      discoverMagic: 'Gundua uchawi',
    },
    welcome: {
      part1: 'Karibu kwenye ',
      part2: 'mustakabali wa ',
      part3: 'retail media',
      part4: 'na ',
      part5: 'transmedia',
    },
    page: {
      heroClose: 'Funga',
      interactiveKicker: 'Uzoefu wa maingiliano',
      interactiveSubtitle: 'Ndani ya video.\nWakati huo huo.\nBila msuguano.',
      ecosystemKicker: 'Ulimwengu mmoja. Uwezekano mwingi.',
      ecosystemTitle: 'Mfumo wa ikolojia\nwa Skoleom',
      partnersTitle: 'Chapa za washirika',
      boutiquesCta: 'Gundua',
      boutiquesTitle: 'Maduka yetu ya sauti na picha',
      boutiquesSubtitle:
        'Mfumo wa ikolojia wa kina. Programu 50+ za wavuti. Kikomo kimoja: mawazo yako.',
    },
    news: {
      badge: 'Mapya',
    },
    boutiques: {
      title: 'Gundua maduka yetu ya sauti na video',
      searchPlaceholder: 'Tafuta tovuti ya Skoleom (mf: market, sport, ott...)',
    },
    sections: {
      welcome: 'Karibu kwenye mustakabali wa retail media na transmedia',
      how: 'Jinsi Skoleom inavyofanya kazi',
      moment: 'Kila wakati. Huwa. Fursa.',
      interactive: 'Uzoefu wa maingiliano',
      universe: 'Ulimwengu mmoja. Uwezekano mwingi.',
      ecosystem: 'Mfumo wa ikolojia wa Skoleom',
      partners: 'Chapa za washirika',
    },
    descriptions: {
      detect:
        'Skoleom hutambua unachotazama na kufanya kila unachokiona kiweze kununuliwa, katika uzoefu wa maingiliano usio wa kawaida.',
    },
    stats: {
      storePages: 'kurasa za Audiovisual Store kwa kila duka.',
    },
  },
  public: {
    stores: {
      hero: {
        titleLine1: 'Gundua',
        titleLine2: 'Maduka yetu ya sauti na picha',
        subtitle: 'Mfumo wa ikolojia wa kina. Programu 50+ za wavuti. Kikomo kimoja: mawazo yako.',
      },
      search: {
        placeholder: 'Tafuta duka au chapa',
        aria: 'Tafuta duka au chapa',
      },
      sections: {
        official: 'Maduka rasmi',
        brands: 'Chapa zinazopatikana',
      },
      showcase: {
        kicker: 'Maduka maalum',
        title: 'Ulimwengu mkuu',
        subtitle: 'Michezo, OTT, muziki na gaming — maduka maarufu ya sauti na picha.',
      },
      carousel: {
        kicker: 'Maduka yote',
        title: 'Maduka ya sauti na picha',
        subtitle: 'Gundua maduka yote katika mfumo wa Skoleom.',
        searchPlaceholder: 'Tafuta duka (mf: sport, music, games...)',
        ariaLabel: 'Karuseli ya maduka ya sauti na picha',
      },
    },
    howItWorks: {
      hero: {
        kicker: 'Jinsi inavyofanya kazi',
        subtitle: 'Ndani ya video. Wakati huo huo. Bila msuguano.',
      },
      steps: {
        '01': {
          title: 'UTAMBULISHO WA AI',
          desc: 'AI yetu hutambua bidhaa, vitu na wakati katika maudhui yoyote.',
        },
        '02': {
          title: 'KAPSULI MAZINGIRA',
          desc: 'Kapsuli za maingiliano zinaonekana kwa wakati halisi bila kukatiza.',
        },
        '03': {
          title: 'GUSA MOJA',
          desc: 'Bofya moja. Hakuna uelekezaji. Hakuna msuguano. Hatua ya papo hapo.',
        },
        '04': {
          title: 'NUNUA KATIKA MUKTADHA',
          desc: 'Maliza ununuzi bila kuacha maudhui unayopenda.',
        },
      },
      demo: {
        titlePrefix: 'Gundua',
        titleHighlight: 'uchawi',
        cta: 'Anzisha demo ya maingiliano',
      },
      showcase: {
        kicker: 'Ulimwengu wa watumiaji',
        title: 'Maduka maalum',
        subtitle: 'Uzoefu wa maingiliano kwa wote, katika maudhui unayopenda.',
      },
      carousel: {
        kicker: 'Maduka yote',
        title: 'Kwa wote',
        subtitle: 'Maduka yote ya watumiaji katika mfumo wa Skoleom.',
        searchPlaceholder: 'Tafuta (mf: page, shop, magazine...)',
        ariaLabel: 'Karuseli ya maduka Kwa wote',
      },
    },
    technology: {
      hero: {
        kicker: 'SeSync · Teknolojia',
        titlePrefix: 'Imeunganishwa na zaidi ya',
        titleMiddle: 'na',
      },
      features: {
        seamless: 'Uzoefu wa ununuzi laini moja kwa moja ndani ya video',
        compatible: 'Inaoana na chapa na waundaji unaowapenda',
        secure: 'Salama na inatii GDPR',
      },
      download: 'Pakua kiendelezi',
      studio: {
        titleLine1: 'Zana ya uchumaji',
        titleLine2Prefix: 'yenye',
        titleLine2Highlight: 'nguvu zaidi duniani',
        description:
          'ERP/DCM SaaS kwa kusimamia, kuchumisha na kuchambua maudhui ya video ya maingiliano. API 300+. Udhibiti kamili.',
      },
    },
  },
  data: {
    showcase: {
      'av-sesports': {
        title: 'Skoleom SeSports',
        desc: 'Interactive sports universe: video-to-commerce, retail media and fan engagement. The group official audiovisual store for sports brands and federations.',
      },
      'av-watch': {
        title: 'Watch on Skoleom',
        desc: 'Skoleom shoppable OTT experience: movies, series and live streams where every visible product becomes accessible in one tap.',
      },
      'av-music': {
        title: 'Skoleom Music',
        desc: 'Label, artists and merchandising. The audiovisual store dedicated to music with direct purchase capsules in clips and concerts.',
      },
      'av-games': {
        title: 'Skoleom Games',
        desc: 'Gaming universe and in-game monetization. Proprietary IP, studio partnerships and interactive capsules embedded in content.',
      },
      'tous-sesync': {
        title: 'SeSync',
        desc: 'Skoleom synchronization engine: in-page purchasing and real-time multi-platform distribution.',
      },
      'tous-shop': {
        title: 'Skoleom Shop',
        desc: 'The group official marketplace: products, merchandise and limited editions available directly from your favorite content.',
      },
      'tous-secontent': {
        title: 'SeContent Creation',
        desc: 'Creation and orchestration of interactive capsules. Intuitive tools to turn any content into a shoppable experience.',
      },
      'tous-magazine': {
        title: 'Skoleom Magazine',
        desc: 'Media and interactive formats: news, features and reports enriched with inline shopping capsules.',
      },
    },
    boutiques: {
      'av-sesports': {
        name: 'Skoleom SeSports',
        description: 'Sports universe and retail media.',
      },
      'av-cares': {
        name: 'Skoleom Cares',
        description: 'Social impact and dedicated programs.',
      },
      'av-games': {
        name: 'Skoleom Games',
        description: 'Games, IP and in-game monetization.',
      },
      'av-watch': {
        name: 'Watch on Skoleom',
        description: 'Shoppable OTT content and live experiences.',
      },
      'av-music': {
        name: 'Skoleom Music',
        description: 'Music, artists and direct merchandising.',
      },
      'tous-page': {
        name: 'Skoleom Page',
        description: 'Skoleom entry point and discovery.',
      },
      'tous-sesync': {
        name: 'SeSync',
        description: 'In-page purchasing and distribution.',
      },
      'tous-shop': {
        name: 'Skoleom Shop',
        description: 'Official marketplace for the ecosystem.',
      },
      'tous-secontent': {
        name: 'SeContent Creation',
        description: 'Create and orchestrate interactive capsules.',
      },
      'tous-magazine': {
        name: 'Skoleom Magazine',
        description: 'Interactive media, news and reports.',
      },
    },
  },
} satisfies LocaleResource;

export default resource;
